var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgKycComplete = function SvgKycComplete(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 70,
    height: 108,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4173C4",
    d: "M62.422.984H7.578A7.31 7.31 0 0 0 .266 8.297v91.406a7.313 7.313 0 0 0 7.312 7.313h54.844a7.313 7.313 0 0 0 7.312-7.313V8.297A7.31 7.31 0 0 0 62.422.984"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#kycComplete_svg__a)",
    d: "M69.734 8.297V86.39a6 6 0 0 1-6 6H6.266a6 6 0 0 1-6-6V8.297A7.31 7.31 0 0 1 7.578.984h54.844a7.31 7.31 0 0 1 7.312 7.313"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#EEE",
    d: "M40.484 101.531H29.516a1.827 1.827 0 1 1 0-3.656h10.968a1.828 1.828 0 0 1 0 3.656"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#kycComplete_svg__b)",
    d: "M22.203 1.984a1 1 0 0 1 1-1h23.594a1 1 0 0 1 1 1v2.657a3.656 3.656 0 0 1-3.656 3.656H25.859a3.656 3.656 0 0 1-3.656-3.656z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M41.333 72.281a1.827 1.827 0 0 0-2.497-.67l-2.008 1.16v-2.318a1.828 1.828 0 0 0-3.656 0v2.318l-2.008-1.16a1.828 1.828 0 1 0-1.828 3.168l2.007 1.159-2.007 1.158a1.828 1.828 0 0 0 1.828 3.167l2.008-1.159v2.318a1.828 1.828 0 0 0 3.656 0v-2.318l2.008 1.16a1.828 1.828 0 1 0 1.828-3.168l-2.007-1.159 2.007-1.158a1.83 1.83 0 0 0 .67-2.498M23.052 72.281a1.827 1.827 0 0 0-2.497-.67l-2.008 1.16v-2.318a1.828 1.828 0 0 0-3.656 0v2.318l-2.008-1.16a1.828 1.828 0 1 0-1.828 3.168l2.007 1.159-2.007 1.158a1.828 1.828 0 0 0 1.828 3.167l2.008-1.159v2.318a1.828 1.828 0 0 0 3.656 0v-2.318l2.008 1.16a1.828 1.828 0 1 0 1.828-3.168l-2.007-1.159 2.007-1.158a1.83 1.83 0 0 0 .67-2.498M58.945 77.096l-2.007-1.159 2.007-1.158a1.829 1.829 0 1 0-1.828-3.167l-2.008 1.159v-2.318a1.828 1.828 0 0 0-3.656 0v2.318l-2.008-1.16a1.827 1.827 0 0 0-2.68 2.058 1.83 1.83 0 0 0 .852 1.11l2.007 1.159-2.007 1.158a1.829 1.829 0 0 0 1.828 3.167l2.008-1.159v2.318a1.828 1.828 0 0 0 3.656 0v-2.318l2.008 1.16a1.827 1.827 0 0 0 2.68-2.058 1.83 1.83 0 0 0-.852-1.11"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#kycComplete_svg__c)",
    d: "M35.684 19.87a1.055 1.055 0 0 0-1.368 0 27.97 27.97 0 0 1-16.618 6.67c-.544.03-.98.473-.98 1.018v9.989c0 15.88 15.517 22.671 17.96 23.642q.323.128.644 0c2.443-.97 17.96-7.762 17.96-23.642v-9.99c0-.544-.436-.986-.98-1.016a27.97 27.97 0 0 1-16.618-6.67"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#EEE",
    d: "M33.172 48.516a1.82 1.82 0 0 1-1.293-.536l-5.484-5.484a1.828 1.828 0 0 1 2.585-2.585l4.192 4.191 9.676-9.676a1.827 1.827 0 1 1 2.585 2.585L34.464 47.98a1.82 1.82 0 0 1-1.292.536"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "kycComplete_svg__a",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-58.65805 82.78138 -72.63045 -51.4652 64.45 6.935)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9DC2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D7FEB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "kycComplete_svg__b",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(163.059 21.769 3.968)scale(23.5214 11.4526)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE0B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CD9A58"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "kycComplete_svg__c",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(129.202 18.58 22.163)scale(50.8563 43.51)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE0B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CD9A58"
  })))));
};
export default SvgKycComplete;